import { clsx } from 'clsx';
import { ScrollableContainer } from '@/components/common/ScrollableContainer';

interface StatusChipsProps {
  options: Array<{ value: string; label: string; count?: number }>;
  selected: string;
  onChange: (value: string) => void;
}

export function StatusChips({ options, selected, onChange }: StatusChipsProps) {
  return (
    <ScrollableContainer scrollClassName="gap-2 py-1" scrollAmount={160}>
      {options.map((opt) => (
        <button
          key={opt.value}
          onClick={() => onChange(opt.value)}
          className={clsx(
            'flex-shrink-0 px-3 py-1.5 rounded-full text-xs font-medium transition-colors whitespace-nowrap cursor-pointer',
            selected === opt.value
              ? 'bg-brand-primary text-white shadow-xs font-semibold'
              : 'bg-surface-secondary text-text-secondary hover:bg-surface-tertiary hover:text-text-primary border border-border'
          )}
        >
          {opt.label}
          {opt.count !== undefined && (
            <span className={clsx(
              'ml-1.5 px-1.5 py-0.5 rounded-full text-[10px] font-bold',
              selected === opt.value ? 'bg-white/20 text-white' : 'bg-surface-tertiary text-text-muted border border-border/50'
            )}>
              {opt.count}
            </span>
          )}
        </button>
      ))}
    </ScrollableContainer>
  );
}
